export default "__VITE_ASSET__COMv1Uc1__"